import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintEntityDetail } from '.';

/**
 * @component {kat-blueprint-entity-detail-focus} KatBlueprintEntityDetailFocus Component used to place and filter components within the focus section.
 * @slot default Blueprint content for focus section.
 */
@register(KatBlueprintEntityDetail.slotMapping.focus.name)
export class KatBlueprintEntityDetailFocus extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintEntityDetail.slotMapping.focus.name,
      KatBlueprintEntityDetail.slotMapping.focus.allowed
    );
  }
}
